window.addEventListener('DOMContentLoaded', () => {

  const html = document.documentElement;
  const canvas = document.getElementById("hero-lightpass");

  if (canvas) {

    const context = canvas.getContext("2d");
    const featElem = document.querySelector('.home-features');
    let elementHeight, elementTop;
   
    const frameCount = canvas.dataset['count'];
    const currentFrame = index => (
      `${window.urls.slides_uri}slide${(index + 1).toString()}.png`
    )
  
    const preloadImages = () => {
      for (let i = 1; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
      }
    };
  
    const img = new Image()
    img.src = currentFrame(1);
    canvas.width = 900;
    canvas.height = 900;
    img.onload = function () {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, 0, 0);
    }
  
    const updateImage = index => {
      if (index > 0) {
        img.src = currentFrame(index);
        context.drawImage(img, 0, 0);
      }
    }
  
    

    function updateCanvas() {
      const offset = 250;
      elementTop = featElem.offsetTop;
      elementHeight = featElem.offsetHeight;
      const scrollTop = Math.ceil(window.scrollY);
      const minScrollTop = elementTop - window.innerHeight + offset;
      const maxScrollTop = elementTop + elementHeight + offset;

  
      const scrollFraction = (scrollTop - minScrollTop) / (maxScrollTop);
      const frameIndex = Math.min(
        frameCount - 1,
        Math.ceil(scrollFraction * frameCount)
        );
        
      requestAnimationFrame(() => updateImage(frameIndex + 1))
    }

  
  
    function initObserv(sections) {
      sections.forEach((item) => {
        if(item.isIntersecting) {
          
          preloadImages();
          window.addEventListener('scroll', (e) => {
            updateCanvas();  
          });
        } else {
          window.removeEventListener('scroll', (e) => {
            updateCanvas();  
          });
        }
        
      });
    }
  
    const options = {
      threshold: .1
    }
  
    const observer = new IntersectionObserver(initObserv, options);
    observer.observe(featElem);
  }




const intersectionAtTopOrBottomElement = document.querySelectorAll('.home-feature');
const featuresColumn = document.querySelector('.home-features__list');

const elementHasIntersected = (entries, o) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }  else {
       // entry.target.classList.remove('active');
      }
    });

};
const ioConfiguration = {
  /**
   * This rootMargin creates a horizontal line vertically centered
   * that will help trigger an intersection at that the very point.
   */
  rootMargin: '-50% 0% -50% 0%',

  threshold: 0
};

const observer = new IntersectionObserver(elementHasIntersected, ioConfiguration);

intersectionAtTopOrBottomElement.forEach((item) => {
  observer.observe(item);
});

});